module.exports = __webpack_public_path__ + "static/img/jiedanwuyou.ac6767b9.jpeg";